export const SAM_ENCODER_MODEL_PATH = '/models/sam2.1_hiera_tiny_image_encoder.onnx';
export const SAM_DECODER_MODEL_PATH = '/models/sam2.1_hiera_tiny_mask_refinement_decoder.onnx';
export const SAM_DECODER_POINTS_MODEL_PATH = '/models/sam2.1_hiera_tiny_mask_refinement_decoder_points.onnx';
export const SAM_INPUT_SIZE = 1024;
export const SAM_MASK_SIZE = 256;
/** Progress steps reported via onStatus during SAM inference. */
export const SAM_STATUS = {
    LOADING_SESSION: 'loading-session',
    PREPARING: 'preparing',
    ENCODING: 'encoding',
    DECODING: 'decoding',
};

/** Maximum number of click prompts per SAM inference call (matches Python SAM2Processor max_num_points). */
export const MAX_SAM_PROMPT_POINTS = 10;
export const IMAGENET_MEAN = [0.485, 0.456, 0.406];
export const IMAGENET_STD = [0.229, 0.224, 0.225];
export const IMAGE_SCALE_FACTOR = 255;